import { Timestamp } from 'firebase/firestore';

export type BudgetItem = {
    id?: string;
    name: string;
    amount: number;
    targetAmount: number;
    spent: number;
    category: string;
    date: Date;
    createdBy?: string;
    symbol?: string;
};

export type BudgetData = {
    items: Record<string, BudgetItem[]>;
};

export type DeletedDataArchive = {
    type: 'BUDGET_DELETION' | 'ACCOUNT_DELETION';
    userId: string;
    deletedAt: Date;
    budgetId: string;
    originalData: any;
  };

export type BudgetState = {
    budgetItems: BudgetItem[];
    totalBudget: number;
    assignedBudget: number;
    availableToBudget: number;
    categories: string[];
    month: number;
    year: number;
    loading: boolean;
    error: string | null;
    archived: boolean;
};

export type BudgetAction =
    | { type: 'DELETE_BUDGET'; payload: string }
    | { type: 'ARCHIVE_BUDGET'; payload: any }
    | { type: 'LOAD_BUDGET_ITEMS'; payload: Partial<BudgetState> }
    | { type: 'ADD_BUDGET_ITEM'; payload: BudgetItem }
    | { type: 'UPDATE_BUDGET_ITEM'; payload: BudgetItem }
    | { type: 'DELETE_BUDGET_ITEM'; payload: string }
    | { type: 'CHANGE_MONTH'; payload: { month: number; year: number } }
    | { type: 'SET_LOADING'; payload: boolean }
    | { type: 'SET_ERROR'; payload: string | null }
    | { type: 'UPDATE_AVAILABLE_BUDGET'; payload: number };

export type BudgetContextType = {
    state: BudgetState;
    loadBudgetItems: (filters?: { category?: string; month?: number; year?: number }) => Promise<void>;
    addBudgetItem: (budgetItem: Omit<BudgetItem, 'id' | 'createdBy'>) => Promise<void>;
    updateBudgetItem: (budgetItem: BudgetItem) => Promise<void>;
    deleteBudgetItem: (budgetItemId: string) => Promise<void>;
    changeMonth: (month: number, year: number) => void;
    autoAssign: () => Promise<void>;
    assignMoney: (categoryId: string, amount: number) => Promise<void>;
    clearError: () => void;
};

// constants/budget.ts
export const defaultCategories = {
    'wants': ['entertainment', 'shopping', 'travel', 'gifts'],
    'needs': ['foodDining', 'groceries', 'transportation', 'health', 'education'],
    'bills': ['utilities', 'rental', 'phone', 'internet'],
    'income': ['sales']
};

export const categorySymbols: { [key: string]: string } = {
    'foodDining': '🍽️',
    'transportation': '🚗',
    'utilities': '🔌',
    'entertainment': '🎬',
    'shopping': '🛒',
    'health': '⚕️',
    'travel': '✈️',
    'education': '🎓',
    'gifts': '🎁',
    'phone': '📱',
    'internet': '🛜',
    'groceries': '🛒',
    'rental': '🏠',
    'sales': '🧾'
};